import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Calendar, Award, BookOpen } from "lucide-react";
import { EDUCATION } from "../data/portfolioData";

export default function Education() {
  return (
    <section id="education" className="py-20 relative overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-mono font-semibold"
          >
            <GraduationCap size={14} /> ACADEMIC BACKGROUND
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900"
          >
            Education & <span className="gradient-text-indigo">Qualifications</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-slate-600 text-base leading-relaxed"
          >
            Academic foundation in Computer Science Engineering, physical sciences, and analytical problem-solving.
          </motion.p>
        </div>

        {/* Education Timeline Grid */}
        <div className="mt-14 max-w-4xl mx-auto space-y-6">
          {EDUCATION.map((edu, idx) => (
            <motion.div
              key={edu.school}
              initial={{ opacity: 0, x: idx % 2 === 0 ? -30 : 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.15 }}
              className="p-8 rounded-3xl bg-white border border-slate-200 backdrop-blur-xl hover:border-emerald-400 transition-all duration-300 shadow-sm hover:shadow-md space-y-4 flex flex-col sm:flex-row items-start justify-between gap-6 group"
            >
              <div className="space-y-2 flex-1">
                <div className="flex items-center gap-2">
                  <div className="p-2 rounded-xl bg-emerald-50 text-emerald-600 border border-emerald-200">
                    <BookOpen size={18} />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 group-hover:text-emerald-600 transition-colors">
                    {edu.school}
                  </h3>
                </div>

                <div className="text-sm font-semibold text-slate-700">
                  {edu.degree}
                </div>

                <p className="text-xs text-slate-600 leading-relaxed">
                  {edu.details}
                </p>
              </div>

              <div className="flex flex-row sm:flex-col items-start sm:items-end justify-between w-full sm:w-auto border-t sm:border-t-0 pt-4 sm:pt-0 border-slate-100 gap-2 shrink-0">
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-mono font-semibold bg-slate-100 text-slate-700 border border-slate-200">
                  <Calendar size={12} /> {edu.year}
                </span>

                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-mono font-bold bg-emerald-50 text-emerald-700 border border-emerald-200">
                  <Award size={12} /> {edu.score}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
